import React from 'react'

export default function StockOutItemInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .stockout-wrapper {
          padding: 20px;
          box-sizing: border-box;
        }
        .stock-out-item-container {
          /*border: solid 0.75px lightgrey;*/
          /*width: 90%;*/
          margin: auto;
          user-select: text;
        }
        .item-details-table {
          width: 100%;
          font-size: 0.65em;
        }
        .item-details-table thead {
          background-color: lightgrey;
        }
        .item-details-table th, td {
          text-align: left;
          padding: 8px;
        }
        .stock-out-header-container {
          margin: 2px;
          padding: 10px;
          background-color: lightgrey;
          font-size: 1.5rem;
          font-weight: bold;
        }
        .stock-out-header-details-container {
          display: flex;
          padding: 10px;
        }
        .fields-group-container {
          flex: 1;
        }
        .field-group {
          margin: 5px;
          font-size: 0.65em;
          display: flex;
        }
        .field-group label {
          font-weight: bold;
          flex: 3;
        }
        .field-group p {
          flex: 5;
        }

        .expiration-date-input-container { display: flex; }
        .expiration-date-input-container label {
          flex: 0.8;
          margin: auto;
          font-size: 0.8em;
          text-align: left;
        }
        .expiration-date-input-container input[type='date'] { flex: 2; }

        .expiration-date-container {
          display: flex;
          font-size: 0.75rem;
          background-color: #888;
          border-radius: 5px;
          color: white;
          padding: 3px;
          padding-bottom: 5px;
          width: 160px;
          margin-top: 3px;
          text-align: center;
        }
        .expiration-date { color: lightgreen; }

        .log-container {
          font-size: 0.8rem;
          margin-top: 10px;
          border-top: dotted 0.3px black;
        }
      `}
      </style>
    </React.Fragment>
  )
}
